// extracted by mini-css-extract-plugin
module.exports = {"root":"AiChatPanel_root__HDBaE","chatInputWrapper":"AiChatPanel_chatInputWrapper__uZ3ng","messagesWrapper":"AiChatPanel_messagesWrapper__WszBR"};